export type WeightUnit = 'kg' | 'lb';

export const DEFAULT_WEIGHT_UNIT: WeightUnit = 'kg';

/** Libras por kilogramo. */
export const LB_PER_KG = 2.2046226218;

export function resolveWeightUnit(unit?: string | null): WeightUnit {
  return unit === 'lb' ? 'lb' : DEFAULT_WEIGHT_UNIT;
}

/** Factor para pasar un peso guardado en kg a la unidad de la organización. */
export function weightFactor(unit: WeightUnit): number {
  return unit === 'lb' ? LB_PER_KG : 1;
}
